import React from 'react'
import Button from '@mui/material/Button'
import { IQDialog, Preloader } from '../../common'
import { Stack } from '@mui/material'

interface IProps {
  title?: string | React.ReactNode
  content: string | React.ReactNode
  dataTestId?: string
  isShow: boolean
  onClose: () => void
  onCancel: () => void
  onConfirm: () => void
  confirmationLabel?: string
  cancellationLabel?: string
  shouldAlignBetween?: boolean
  isLoading?: boolean
}

export const ConfirmationAlert = ({
  title,
  content,
  dataTestId,
  isShow,
  onClose,
  onConfirm,
  confirmationLabel,
  cancellationLabel,
  shouldAlignBetween = false,
  onCancel,
  isLoading,
}: IProps) => (
  <IQDialog
    isShow={isShow}
    title={title || ''}
    content={content}
    actions={
      isLoading ? (
        <Preloader style={{ display: 'block', margin: '0 auto' }} />
      ) : (
        <Stack
          direction='row'
          spacing={1}
          alignItems='flex-end'
          sx={{ width: '100%' }}
          justifyContent={shouldAlignBetween ? 'space-between' : 'flex-end'}
        >
          <Button
            variant='outlined'
            onClick={onCancel}
            data-testid={`${dataTestId}-cancel`}
          >
            {cancellationLabel ?? 'Cancel'}
          </Button>
          <Button
            variant='contained'
            onClick={onConfirm}
            data-testid={`${dataTestId}-ok`}
            disabled={isLoading}
          >
            {confirmationLabel ?? 'OK'}
          </Button>
        </Stack>
      )
    }
    onClose={onClose}
    testPrefix={`${dataTestId}-cancel`}
  />
)
